import React, { useState } from "react";
import {
  tableImg,
  LinkIcon,
  ExternalLink,
  CheckSymbolGreen,
  CancelSymbolRed,
  Pending,
  PendingLineGray,
} from "../../../constant/imagePath";
import { AdminTable } from "../../../stories/AdminTable/AdminTable";
import Fonts from "../../../stories/assets/Fonts";
import Colors from "../../../stories/assets/Colors";

import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { SideBarMenu } from "../../../stories/SideBarMenu/SideBarMenu";
import classes from "./Requests.module.css";
import { DropDown } from "../../../stories/DropDown/DropDown";
import { Tooltip } from "../../../stories/Tooltip";
import { Container, Row, Col } from "react-bootstrap";
import { Tabs } from "../../../stories/Tabs/Tabs";
import Certificate from "../../../components/Modals/Admin/Certificate/Certificate";
import MessageExplanationModal from "../../../components/Modals/Admin/MessageExplanationModal/MessageExplanationModal";
import { useHistory, useLocation, Link } from "react-router-dom";

import { TableCell, TableRow } from "@mui/material";
import { Button } from "../../../stories/Button/Button";
import { ReactSVG } from "react-svg";
import Layout from "../Layout/Layout";
import dropDownClasses from "../../../stories/DropDown/DropDown.module.css";

const Requests = () => {
  const [tab, setTab] = useState({ label: "Certificates" });
  const [location1, setLocation1] = useState();
  const [showCertificate, setShowCertificate] = useState(false);
  const [showMessageExplaination, setShowMessageExplaination] = useState(false);
  const [onboardingDecline, setOnboardingDecline] = useState(false);
  const [status, setStatus] = useState();

  // Search State
  const [search, setSearch] = useState('')

  const history = useHistory();

  const dummy = [
    {
      image: tableImg,
      name: "Ann Johnson",
      status: "pending",
      certificates: 2,
      role: "student",
    },
    {
      image: tableImg,
      name: "Sarika Bhimre",
      status: "declined",
      certificates: 1,
      role: "coach",
    },
    {
      image: tableImg,
      name: "Kate Smith",
      status: "approved",
      certificates: 4,
      role: "coach",
    },
  ];
  const certificatestableHeadings = [
    { title: "User Name" },
    { title: "Certificate" },
    { title: "Status" },
  ];
  const profileChecktableHeadings = [
    { title: "User Name" },
    { title: "Profile Onboarding" },
    { title: "Background Check" },
    { title: "Profile Status" },
  ];

  return (
    <>
      <style jsx>{`
        .${dropDownClasses.reactSelect} > div {
          z-index: 3;
        }
      `}</style>
      <div className={classes.AdminTableMain}>
        {/* Layout */}
        <Layout location1={location1} />

        <div className={classes.tableMain}>
          <Container fluid className={classes.container}>
            <h3
              className={classes.marginBlock24}
              style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
            >
              Requests
            </h3>
            <Tabs
              state={tab}
              setState={setTab}
              tabsData={[{ label: "Certificates" }, { label: "Profile Check" }]}
            />
            <Row className={`gx-1 ${classes.mt24}`}>
              <Col md={10}>
                <InputWithSearchIcon state={search} setter={setSearch} />
              </Col>
              <Col md={2}>
                <DropDown
                  placeholder={"status"}
                  options={[{ label: "All", value: "all" }]}
                  state={status}
                  setter={setStatus}
                />
              </Col>
            </Row>
            <div className={classes.overflowScroll630}>
              <AdminTable
                headings={
                  tab?.label == "Certificates"
                    ? certificatestableHeadings
                    : profileChecktableHeadings
                }
                renderDataWithElement={
                  tab?.label == "Certificates"
                    ? dummy?.map((item) => (
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <div className={classes.tableImgDiv}>
                            <>
                              {item?.role === "student" && (
                                <div className={classes.innerImgCont}>
                                  <img src={item?.image} alt="tableImg" />
                                </div>
                              )}
                              {item?.role === "coach" && (
                                <div className={classes.innerImgCont}>
                                  <img src={item?.image} alt="tableImg" />
                                </div>
                              )}
                            </>
                            <h6
                              style={{
                                ...Fonts.h6,
                                color: Colors.neutralShadesOfNero,
                              }}
                            >
                              {" "}
                              {item?.name}
                            </h6>
                          </div>
                        </TableCell>

                        <TableCell>
                          <div className={classes.aCenter}>
                            <Button
                              icon={LinkIcon}
                              size={"Small"}
                              customStyle={{ marginRight: "12px" }}
                              onClick={() => setShowCertificate(true)}
                            />

                            <p
                              style={{
                                ...Fonts.p1,
                                color: Colors.neutralShadesOfNero,
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.certificates} certificates
                            </p>
                          </div>
                        </TableCell>
                        <TableCell>
                          <p
                            style={{
                              ...Fonts.p1,
                              color: Colors.neutralShadesOfNero,
                            }}
                            className={
                              (item?.status == "pending" &&
                                classes.pending) ||
                              (item?.status == "declined" &&
                                classes.declined) ||
                              (item?.status == "approved" && classes.approved)
                            }
                            onClick={() => setShowMessageExplaination(true)}
                          >
                            {item?.status}
                          </p>
                        </TableCell>
                      </TableRow>
                    ))
                    : dummy?.map((item) => (
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <div className={classes.tableImgDiv}>
                            <>
                              {item?.role === "student" && (
                                <div className={classes.innerImgCont}>
                                  <img src={item?.image} alt="tableImg" />
                                </div>
                              )}
                              {item?.role === "coach" && (
                                <div className={classes.innerImgCont}>
                                  <img src={item?.image} alt="tableImg" />
                                </div>
                              )}
                            </>
                            <h6
                              style={{
                                ...Fonts.h6,
                                color: Colors.neutralShadesOfNero,
                              }}
                            >
                              {" "}
                              {item?.name}
                            </h6>
                          </div>
                        </TableCell>

                        <TableCell>
                          <div className={classes.aCenter}>
                            {item?.status == "declined" && (
                              <Tooltip
                                text={"Rejected"}
                                className={classes.tooltip}
                              >
                                <ReactSVG
                                  src={CancelSymbolRed}
                                  className={classes.icon}
                                  onClick={() => setOnboardingDecline(true)}
                                />
                              </Tooltip>
                            )}
                            {item?.status == "pending" && (
                              <Tooltip
                                text={"Pending"}
                                className={classes.tooltip1}
                              >
                                <ReactSVG
                                  src={PendingLineGray}
                                  className={classes.icon}
                                  onClick={() => setOnboardingDecline(true)}
                                />
                              </Tooltip>
                            )}
                            {item?.status == "approved" && (
                              <Tooltip
                                text={"Approved"}
                                className={classes.tooltip}
                              >
                                <ReactSVG
                                  src={CheckSymbolGreen}
                                  className={classes.icon}
                                  onClick={() => setOnboardingDecline(true)}
                                />
                              </Tooltip>
                            )}

                            {item?.status == "pending" && (
                              <Tooltip
                                text={"Pending"}
                                className={classes.tooltip}
                              >
                                <ReactSVG
                                  src={Pending}
                                  className={classes.icon}
                                  onClick={() => setOnboardingDecline(true)}
                                />
                              </Tooltip>
                            )}

                            <Button
                              icon={ExternalLink}
                              size={"Small"}
                              onClick={() => setShowCertificate(true)}
                            />
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.aCenter}>
                            <ReactSVG
                              src={CheckSymbolGreen}
                              className={classes.icon}
                            />
                            <Button
                              icon={ExternalLink}
                              size={"Small"}
                              onClick={() => setShowCertificate(true)}
                            />
                          </div>
                        </TableCell>
                        <TableCell>
                          <p
                            style={{
                              ...Fonts.p1,
                              color: Colors.neutralShadesOfNero,
                            }}
                            className={
                              (item?.status == "pending" &&
                                classes.pending) ||
                              (item?.status == "declined" &&
                                classes.declined) ||
                              (item?.status == "approved" && classes.approved)
                            }
                            onClick={() => setShowMessageExplaination(true)}
                          >
                            {item?.status}
                          </p>
                        </TableCell>
                      </TableRow>
                    ))
                }
              />
            </div>
          </Container>
        </div>
      </div>
      {showCertificate && (
        <Certificate show={showCertificate} setShow={setShowCertificate} />
      )}
      {showMessageExplaination && (
        <MessageExplanationModal
          title={"Certification decline"}
          show={showMessageExplaination}
          setShow={setShowMessageExplaination}
        />
      )}
      {onboardingDecline && (
        <MessageExplanationModal
          title={"Onboarding decline"}
          show={onboardingDecline}
          setShow={setOnboardingDecline}
        />
      )}
    </>
  );
};

export default Requests;
